'use client';

import type {FC, HTMLAttributes} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

type Props = HTMLAttributes<HTMLDivElement>;

export const FadeInDiv: FC<Props> = ({children, className}, ...rest) => {
	return (
		<AnimatePresence>
			<motion.div
				{...rest}
				className={className}
				initial={{opacity: 0}}
				animate={{opacity: 1}}
				transition={{duration: 0.7}}
			>
				{children}
			</motion.div>
		</AnimatePresence>
	);
};
